import React from 'react';
import { Transition, Icon, List, Button } from 'semantic-ui-react';
import { formatDecimal } from '../../../utils/formatador';
import moment from 'moment';

const tipoPagamento = {
  ATIVACAO: 'Ativação',
  RENOVACAO: 'Renovação',
  ADD_UNIDADE: 'Adição de unidades votantes'
};

// classe: estilo da etiqueta / avatar (habilitada = verde, pendente = âmbar, bloqueada = vermelho)
export const statusPagamento = {
  OP: { descricao: 'Pedido criado', icon: 'clock outline', classe: 'pendente' },
  CO: { descricao: 'Pagamento confirmado', icon: 'check circle', classe: 'habilitada' },
  PE: { descricao: 'Pagamento pendente', icon: 'clock outline', classe: 'pendente' },
  CA: { descricao: 'Pagamento cancelado', icon: 'ban', classe: 'bloqueada' },
};

const ItemHistorico = ({ pagamento, consultarStatus }) => {
  const status = statusPagamento[pagamento.status] || statusPagamento.OP;
  const pendenteNitrus = pagamento.status === 'PE' && pagamento.origem === 'NITRUS';

  return (
    <Transition duration="500" animation="fade up" transitionOnMount={true}>
      <List.Item className="animated-list-item va-un-item">
        <span className={`va-un-avatar ${status.classe === 'bloqueada' ? 'bloqueada' : status.classe === 'pendente' ? 'rascunho' : ''}`} aria-hidden="true">
          <Icon name={pagamento.status === 'CO' ? 'check' : pagamento.status === 'CA' ? 'ban' : 'clock outline'} />
        </span>
        <List.Content className="animated-list-content">
          <List.Header style={{ wordWrap: 'break-word', fontSize: '1.2em', marginBottom: '5px', lineHeight: '1.2em' }}>
            {tipoPagamento[pagamento.tipo] || 'Pagamento'}
            <span style={{ fontWeight: 100 }}>&nbsp;&nbsp;•&nbsp;&nbsp;R$ {formatDecimal(pagamento.valor)}</span>
            <span className={`va-unidade-status ${status.classe}`}>
              <Icon name={status.icon} />
              {status.descricao}
            </span>
          </List.Header>
          <List.Description style={{ fontSize: '1.1em' }}>
            <span className="va-unidade-contato">
              <span><Icon name="home" /> {pagamento.quantidadeUnidades} unidade{pagamento.quantidadeUnidades !== 1 && 's'} votante{pagamento.quantidadeUnidades !== 1 && 's'}</span>
              <span><Icon name="calendar outline" /> Criado em {moment(pagamento.dataAbertura).format('DD/MM/YYYY [às] HH:mm')}</span>
              {pagamento.status === 'CO' && pagamento.dataConfirmacao && (
                <span><Icon name="check" /> Confirmado em {moment(pagamento.dataConfirmacao).format('DD/MM/YYYY')}</span>
              )}
            </span>
          </List.Description>
          {pendenteNitrus && (
            <div className="btn-right">
              {!!pagamento.urlPagamento && (
                <Button as="a" href={pagamento.urlPagamento} target="_blank" rel="noopener noreferrer" className="btn-ui-1 btn-ui-1-basic">
                  <Icon name="external alternate" /> Pagar
                </Button>
              )}
              <Button className="va-btn-acao va-btn-editar" onClick={consultarStatus} aria-label="Atualizar status do pagamento">
                <Icon name="refresh" /> Atualizar
              </Button>
            </div>
          )}
        </List.Content>
      </List.Item>
    </Transition>
  );
};

export default ItemHistorico;
